import { cn } from "@/lib/utils";
import { resolveRelationshipId, typographyVariantClass } from "@/lib/utils/theme-configuration-class";
import { Toggle as BaseUIToggle, type ToggleProps as BaseUIToggleProps } from "@base-ui/react/toggle";
import { ToggleGroup as BaseUIToggleGroup, ToggleGroupProps as BaseUIToggleGroupProps } from "@base-ui/react/toggle-group";
import { ToggleGroup as ToggleGroupT } from "@/payload-types";
import "./style.scss";

export type ToggleGroupVariant = ToggleGroupT | ToggleGroupT["id"] | "default" | null;

interface ToggleGroupProps<T extends string = string> extends BaseUIToggleGroupProps<T> {
	variant?: ToggleGroupVariant;
}

export const ToggleGroup: React.FC<ToggleGroupProps> = ({ variant = "default", className, defaultValue, multiple, children, ...props }) => {
	const variantId = resolveRelationshipId(variant);

	return (
		<div className={cn(`ms-tg-${variantId}`, className)}>
			<BaseUIToggleGroup defaultValue={defaultValue} {...props} className={cn("ms-toggle-group p-1 gap-1 flex border overflow-auto")} multiple={multiple}>
				{children}
			</BaseUIToggleGroup>
		</div>
	);
};

interface ToggleProps extends BaseUIToggleProps<string> {
	typographyVariant?: string | number | { id: string | number } | null | undefined;
}

export const Toggle: React.FC<ToggleProps> = ({ typographyVariant, children, value, className, ...props }) => {
	const typographyClass = typographyVariantClass(typographyVariant);
	return (
		<BaseUIToggle
			{...props}
			value={value}
			className={cn(
				"ms-toggle whitespace-nowrap flex items-center justify-center select-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1",
				className,
				typographyClass,
			)}
		>
			{children}
		</BaseUIToggle>
	);
};
